import { render, staticRenderFns } from "./NavMenuSectionTitle.vue?vue&type=template&id=493e3efd&"
import script from "./NavMenuSectionTitle.vue?vue&type=script&lang=js&"
export * from "./NavMenuSectionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VSubheader})
